import React, { useState, createContext } from "react";

export const ProductsContext = createContext();
const ProductsProvider = (props) => {
  const [product1, setProduct1] = useState({});
  const [product1_old, setProduct1_old] = useState({});
  const [product2, setProduct2] = useState({});
  const [product3, setProduct3] = useState({});
  const [product4, setProduct4] = useState({});
  const [product4_old, setProduct4_old] = useState({});
  const [product1_2Visible, setProduct1_2Visible] = useState(true);
  return (
    <ProductsContext.Provider
      value={{
        p1: [product1, setProduct1],
        p1_old: [product1_old, setProduct1_old],
        p2: [product2, setProduct2],
        p3: [product3, setProduct3],
        p4: [product4, setProduct4],
        p4_old: [product4_old, setProduct4_old],
        p1_p2Visible: [product1_2Visible, setProduct1_2Visible],
      }}
    >
      {props.children}
    </ProductsContext.Provider>
  );
};

export default ProductsProvider;
